import { io, Socket } from "socket.io-client";

const SOCKET_URL = "https://shifdo.co.in/api";
//const SOCKET_URL = "http://localhost:1212";

export const socket: Socket = io(SOCKET_URL, {
  autoConnect: true,
  reconnection: true,
  transports: ["websocket"],
});

let initialized = false;

export const initSocket = () => {
  if (initialized) return;

  initialized = true;

  socket.on("connect", () => {
    //console.log("Connected to Socket.io server:", socket.id);
  });

  socket.on("disconnect", () => {
    //console.log("Disconnected from Socket.io server");
  });

  socket.on("connect_error", (error) => {
    //console.error("Socket connection error:", error);
  });
};